<template>
  <iRow
    v-if="rendersAsCaret"
    width="hug"
    height="hug"
    vertical-align="middle"
    :style-overrides="inputStyleOverrides"
    style="cursor: pointer"
    @click="toggleFromCaret"
  >
    <iIcon :icon="value ? 'caret-right' : 'caret-down'" />
  </iRow>
  <iCheckbox
    v-else
    v-model="value"
    :label="labelValue"
    :style-overrides="inputStyleOverrides"
    @update:model-value="commitOnChange"
  />
</template>

<script>
import { plainLabelText } from "%/dynamic-component-editor/helpers/plain-label-text.mjs";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import DynamicAppInputOptionsMixin from "%/dynamic-component-editor/standard-elements/dynamic-app-elements/inputs/dynamic-app-input-options-mixin";
import Label from "%/dynamic-component-editor/options/label";
import CommitAction from "%/dynamic-component-editor/options/commit-action";
import SeedField from "%/dynamic-component-editor/options/seed-field";
import CheckboxDisplay, { CHECKBOX_DISPLAY_CARET } from "%/dynamic-component-editor/options/checkbox-display";

import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BorderColor from "%/dynamic-component-editor/options/border-color";
import BorderWidth from "%/dynamic-component-editor/options/border-width";

export default {
  name: "DynamicAppCheckboxInputElement",
  mixins: [DynamicElementMixin, DynamicElementWithContext, DynamicAppInputOptionsMixin],
  elementPanelSettings: {
    displayName: "Text",
    elementGroup: "general",
    displayIcon: "pencil",
    elementType: "element",
  },
  hidden: true,
  options: [
    Label,
    CommitAction,
    SeedField,
    CheckboxDisplay,
    BackgroundColor,
    BorderColor,
    BorderWidth,
  ],
  optionBundles: [
    new BasicTextOptions({}, {
      "font-family": true,
    }),
    new SpacingOptions(),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
  ],
  computed: {
    rendersAsCaret() {
      return this.getOptionValue(CheckboxDisplay) === CHECKBOX_DISPLAY_CARET;
    },
    labelValue() {
      return plainLabelText(this.getOptionValue(Label));
    },
    // iCheckbox spaces through `container*` keys, paints the box via
    // `inputColor`/`inputBorderColor` and the label via `label*` keys.
    inputStyleOverrides() {
      const padding = this.appInputPadding;
      const margins = this.appInputMargins;
      return this.appInputStyleOverrides({
        inputColor: this.appInputBackgroundColor,
        inputBorderColor: this.appInputBorderColor,
        labelFontColor: this.appInputFontColor,
        labelFontSize: this.appInputFontSize,
        labelFontWeight: this.appInputFontWeight,
        containerPaddingTop: padding.top ?? null,
        containerPaddingBottom: padding.bottom ?? null,
        containerPaddingLeft: padding.left ?? null,
        containerPaddingRight: padding.right ?? null,
        containerMarginTop: margins.marginTop ?? null,
        containerMarginBottom: margins.marginBottom ?? null,
        containerMarginLeft: margins.marginLeft ?? null,
        containerMarginRight: margins.marginRight ?? null,
      });
    },
    value: {
      get() {
        return this.valueFromContext;
      },
      set(value) {
        if (!this.editMode) {
          this.valueFromContext = value;
        }
      },
    },
  },
  methods: {
    toggleFromCaret() {
      this.value = !this.value;
      this.commitOnChange();
    },
    async commitOnChange() {
      await this.$nextTick();
      this.triggerNamedAction(this.getOptionValue(CommitAction));
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
